import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../../atom/ModalAtom';
import CntWrap from '../../component/admin/CntWrap';
import SearchOptionWrap from '../../component/SearchOptionWrap';
import InputTitleWrap from '../../component/InputTitleWrap';
import Input from '../../component/Input';
import TableOptionWrap from '../../component/TableOptionWrap';
import Select from '../../component/Select';
import { HistoryTypeList, SizeList } from '../../model/common.dto';
import Table from '../../component/Table';
import { adminAPI } from '../../api/axiosIndex';
import {
  HistoryDto,
  HistoryResDto,
  HistorySearchDto,
} from '../../model/user.dto';
import Pagenation from '../../component/Pagenation';

const History = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const navigate = useNavigate();

  const [type, setType] = useState('ALL');
  const [passid, setPassid] = useState('');
  const [userNumber, setUserNumber] = useState('');
  const [nickname, setNickname] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState('1');
  const [size, setSize] = useState('10');
  const [history, setHistory] = useState<HistoryDto[]>([]);
  const [total, setTotal] = useState('');

  const sort = 'createdAt';
  const order = 'desc';

  const handleHistory = async (resetType?: string) => {
    const dto: HistorySearchDto = {
      type,
      passid,
      userNumber,
      nickname,
      startDate,
      endDate,
      page: Number(page),
      size: Number(size),
      sort,
      order,
    };

    if (resetType === 'pageReset') {
      dto.page = 1;
      setPage('1');
    }

    if (resetType === 'allReset') {
      dto.type = 'ALL';
      dto.passid = '';
      dto.userNumber = '';
      dto.nickname = '';
      dto.startDate = '';
      dto.endDate = '';
      dto.page = 1;
      dto.size = 10;
      setType('ALL');
      setPassid('');
      setUserNumber('');
      setNickname('');
      setStartDate('');
      setEndDate('');
      setPage('1');
      setSize('10');
    }

    const { data } = await adminAPI.getHistory(dto);

    setTotal(String(data.total));
    setHistory(data.results);
  };

  const handleSearch = () => {
    if (startDate && endDate) {
      if (new Date(startDate) > new Date(endDate)) {
        alert('시작 날짜가 종료 날짜보다 클 수 없습니다.');
        return;
      }
    }

    if (startDate !== '' || endDate !== '') {
      if (startDate === '' || endDate === '') {
        alert('시작 날짜 혹은 종료 날짜를 선택해 주세요.');
        return;
      }
    }

    handleHistory('pageReset');
  };

  const handleReset = () => {
    handleHistory('allReset');
  };

  const handlePageChange = (value: number) => {
    setPage(String(value));
  };

  useEffect(() => {
    handleHistory();
  }, [page]);

  useEffect(() => {
    handleHistory('pageReset');
  }, [size]);

  return (
    <>
      <CntWrap title="히스토리 목록">
        <SearchOptionWrap onSearch={handleSearch} onReset={handleReset}>
          <InputTitleWrap title="시작 날짜">
            <Input
              theme="type1"
              type="date"
              width="100%"
              value={startDate}
              setValue={setStartDate}
            />
          </InputTitleWrap>
          <InputTitleWrap title="종료 날짜">
            <Input
              theme="type1"
              type="date"
              width="100%"
              value={endDate}
              setValue={setEndDate}
            />
          </InputTitleWrap>
          <InputTitleWrap title="유형">
            <Select
              theme="type1"
              width="100%"
              value={type}
              setValue={setType}
              options={HistoryTypeList}
            />
          </InputTitleWrap>
          <InputTitleWrap title="아이디">
            <Input
              placeholder="아이디 입력"
              theme="type1"
              type="text"
              width="100%"
              value={passid}
              setValue={setPassid}
            />
          </InputTitleWrap>
          <InputTitleWrap title="사번">
            <Input
              placeholder="사번 입력"
              theme="type1"
              type="text"
              width="100%"
              value={userNumber}
              setValue={setUserNumber}
            />
          </InputTitleWrap>
        </SearchOptionWrap>
        <TableOptionWrap postNum={String(total)}>
          <Select
            theme="type1"
            width="150px"
            value={size}
            setValue={setSize}
            options={SizeList}
          />
        </TableOptionWrap>
        <Table
          theme="type1"
          thList={['No', '유형', '아이디', '사번', '닉네임', '로그', '날짜']}
        >
          {history.map((user, index) => (
            <tr key={user.id}>
              <td>{index + 1 + (Number(page) - 1) * Number(size)}</td>
              <td>
                {{
                  ENTRY: '입차',
                  EXIT: '출차',
                  POUR: '타설',
                }[user.type] || '기타'}
              </td>
              <td>{user.passid}</td>
              <td>{user.userNumber}</td>
              <td>{user.nickname}</td>
              <td style={{ textAlign: 'left' }}>{user.detail}</td>
              <td>{user.createdAt}</td>
            </tr>
          ))}
        </Table>
        {Number(total) > 0 && (
          <Pagenation
            listAllLength={Number(total)}
            listLimit={Number(size)}
            onCurrentPageChange={handlePageChange}
          />
        )}
      </CntWrap>
    </>
  );
};

export default History;
